import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/userEntitlement/importer/userEntitlementImporterActions';

export default importerReducers(actions);
